import cn from 'clsx'
import * as React from 'react'
import styles from './index.module.css'

/**
 * A animated loading indicator component that displays a spinning circle.
 * Uses SVG animation to create a smooth loading effect.
 *
 * @param className - Optional CSS class name for custom styling
 * @returns An SVG-based loading spinner component
 */
// copy-paste from https://cssfx.dev/
const LoadingIndicator = ({
  className,
}: {
  className?: string
}): React.ReactElement<'svg'> => (
  <svg
    width="25"
    height="25"
    viewBox="25 25 50 50"
    className={cn(styles.loadingIndicator, className)}
  >
    <circle cx="50" cy="50" r="20" className={styles.loadingIndicatorCircle} />
  </svg>
)

export default LoadingIndicator
